module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "more",
    style: ({
      backgroundColor: _vm.theme.background,
      borderColor: _vm.theme.border2
    })
  }, [_c('div', [_c('div', {
    staticClass: "more__item"
  }, [_c('svg', {
    attrs: {
      "fill": _vm.theme.icon2,
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("by Ion Lupița")])]), _vm._v(" "), _c('div', {
    staticClass: "more__item"
  }, [_c('svg', {
    attrs: {
      "fill": _vm.theme.icon2,
      "height": "24",
      "width": "24"
    }
  }, [_c('use', {
    attrs: {
      "href": "#iconList"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("by Andrei Roman")])]), _vm._v(" "), _c('div', {
    staticClass: "more__item"
  }, [_c('svg', {
    attrs: {
      "fill": _vm.theme.icon2,
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0V0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("&")]), _vm._v(" "), _c('svg', {
    attrs: {
      "fill": _vm.theme.icon2,
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3zm13.71-9.37l-1.34-1.34c-.39-.39-1.02-.39-1.41 0L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("by Daniel Pintilei")])]), _vm._v(" "), _c('div', {
    staticClass: "more__item"
  }, [_c('svg', {
    attrs: {
      "fill": _vm.theme.icon2,
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM11 20v-5.5H9L13 7v5.5h2L11 20z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("by Netlify")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-138955d8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/More.vue
// module id = 127
// module chunks = 1